import React from "react"

const Message = ({ HitsCount }) => {
	if (HitsCount === null) {
		return (<>検索できます</>)
	}
	else if (HitsCount === 0) {
		return (<>0件ヒットです...</>)
	}
	else {
		return (<>{HitsCount}件ヒットです</>)
	}
}

export default Message